import { BUTTON_DISPLAY_NAME } from '../Button/Button.js';
import './../../vendor/tslib/tslib.es6.js';
import 'react';
import 'classnames';
import '../Icon/Icon.module.css.js';
import '../Button/LoadingButton.module.css.js';

function extractDisplayName(type) {
    return type.displayName || type.name || 'Unknown';
}
function isSupportedCtaComponent(component) {
    var componentType = component.type;
    if (typeof componentType === 'function') {
        var displayName = extractDisplayName(componentType);
        return displayName === BUTTON_DISPLAY_NAME;
    }
    return false;
}

export { extractDisplayName, isSupportedCtaComponent };
//# sourceMappingURL=utils.js.map
